import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { AccountAlert } from './AccountAlert';
import AccountFooter from './AccountFooter';
import UserPreferences from './UserPreferences';
import { HublessPortalPicker } from './HublessPortalPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HublessAccountsMenu = memoWithDisplayName('HublessAccountsMenu', ({
  avatarUrl,
  userName,
  userEmail,
  accounts
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AccountAlert, {}), /*#__PURE__*/_jsx(UserPreferences, {
      avatarUrl: avatarUrl,
      userName: userName,
      userEmail: userEmail
    }), /*#__PURE__*/_jsx(HublessPortalPicker, {
      accounts: accounts
    }), /*#__PURE__*/_jsx(AccountFooter, {})]
  });
});